export default function Background(){
    return(
        <div className="backgroundImg">
        </div>
    )
}